import { isFunction } from '../utils';

/**
 * 解析 defaultData，支持函数形式。
 * @param data - 静态数据或返回数据的函数
 * @returns 解析后的数据
 */
function resolveDefaultData<T>(
  data: Partial<T> | (() => Partial<T>) | null | undefined,
): Partial<T> | null | undefined {
  if (!data) return data;
  if (isFunction(data)) return data();
  return data;
}

export {
  resolveDefaultData,
};
